import { useCookieContext } from 'context';
import React, { useEffect } from 'react';

import Chat from 'components/chat/Chat';
import { MessagesProvider } from 'components/chat/MessagesContext';
import './App.scss';

type Environment = 'goat-stage' | 'goat-dev' | 'goat-prod';
type EnvironmentURL = `https://web${string}.demandbase.com` | 'https://web.demandbase.com';

const ENV_MAPPINGS: Record<Environment, EnvironmentURL> = {
  'goat-stage': 'https://web.stg.demandbase.com',
  'goat-dev': 'https://web.gdpr-dev.demandbase.com',
  'goat-prod': 'https://web.demandbase.com',
};

const ENV_KEYS: Environment[] = ['goat-stage', 'goat-dev'];

function GetClientOriginURL() {
  const hostname = window.location.hostname;
  const matchedEnv = ENV_KEYS.find((env) => hostname.includes(env));
  return ENV_MAPPINGS[matchedEnv as Environment] || ENV_MAPPINGS['goat-prod'];
}

const App = (): React.ReactElement => {
  const { setCookie } = useCookieContext();

  useEffect(() => {
    window.addEventListener('message', (e: any) => {
      const originUrl = GetClientOriginURL();
      if (e.origin !== originUrl) {
        return;
      }
      if (e.data?.type === 'SET_COOKIE') {
        setCookie(e.data.data);
      }
      return;
    });
    return () =>
      window.removeEventListener('message', () => {
        console.log('Event listener removed');
      });
  }, []);

  return (
    <div className='App'>
      <MessagesProvider>
        <Chat />
      </MessagesProvider>
    </div>
  );
};

export default App;
